export default "__VITE_ASSET__DMU$nDuR__"